import React from "react";
import { connect } from "react-redux";
import { string, arrayOf, bool, shape, func } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomData from "pages/_components/CustomData/CustomData";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import CustomText from "pages/_components/CustomText/CustomText";
import { Link } from "react-router-dom";
import classNames from "classnames";
import * as i18n from "util/i18n";

import { actions as accountsActions } from "reducers/accounts";
import { push } from "connected-react-router";
import gaEventTracker, { events } from "util/gaEventTracker";

import { isIOS } from "react-device-detect";
import Button from "pages/_components/Button";

const AccountListFC = ({ dataToList, isDesktop, dispatch, displayNextBatch, hasMoreData }) => {
    const getLabel = (label) => {
        if (label === "alias not set") {
            return i18n.get("accounts.accountLabel.alias");
        }
        return label;
    };

    const getProductType = (accountType) => `productType.${accountType}`;

    const setBalances = (account) => {
        dispatch(accountsActions.filterBalances(account));
    };

    // const handleInternalTransfer = (accountId, currency) => {
    //     gaEventTracker.triggerEvent(events.cuentas_transferir_entre_cuentas());
    //     dispatch(
    //         push({
    //             pathname: `/transfers`,
    //             state: { tab: 0, accountId, currency },
    //         }),
    //     );
    // };

    const handleOtherTransfer = (accountId, currency) => {
        gaEventTracker.triggerEvent(events.cuentas_transferir_terceros());
        dispatch(
            push({
                pathname: `/transfers`,
                state: { tab: 1, accountId, currency },
            }),
        );
    };

    const handleEmitEcheq = (accountId) => {
        gaEventTracker.triggerEvent(events.cuentas_emitir_echeq());
        dispatch(
            push({
                pathname: `/echecks/emit`,
                state: { accountId },
            }),
        );
    };

    return (
        <GridTable className={classNames("products-list")}>
            {dataToList.map((rowData) => (
                <GridTable.Container
                    rowId={rowData.productId}
                    columns={5}
                    key={rowData.rowId}
                    onClick={() => setBalances(rowData)}
                    renderAs={Link}
                    to={`/accounts/${rowData.productId}`}
                    className={isIOS ? "mb-5 gap-5" : "gap-5"}>
                    <GridTable.Data columnStart={1} rowStart={1} rowWidth={1} alignX="flex-start" alignY="flex-start">
                        <GridTable className="product-info">
                            <GridTable.Container>
                                <GridTable.Data columnStart={1} alignY="flex-start">
                                    <CustomData
                                        dataClass={
                                            rowData.blocked === "S" ? "custom-data-title blocked" : "custom-data-title"
                                        }
                                        titleText={getLabel(rowData.label)}
                                    />
                                </GridTable.Data>
                                <GridTable.Data columnStart={2} rowStart={isDesktop ? 3 : 1}>
                                    {rowData.blocked === "S" ? (
                                        <CustomText
                                            text="accounts.accountStatus.Blocked"
                                            textType="I18N"
                                            className="ml-0 tag tag-error"
                                        />
                                    ) : null}
                                </GridTable.Data>
                                <GridTable.Data
                                    columnStart={1}
                                    className={isDesktop && "data-amount content-data-strong"}>
                                    <CustomText
                                        className={rowData.blocked === "S" ? "blocked" : ""}
                                        text={getProductType(rowData.accountType)}
                                        textType="I18N"
                                    />
                                </GridTable.Data>
                                <GridTable.Data columnStart={isDesktop ? 1 : 2}>
                                    <CustomText
                                        className={
                                            rowData.blocked === "S"
                                                ? `${!isDesktop && "pl-4"} accounts-account-list-number blocked`
                                                : `${!isDesktop && "pl-4"} accounts-account-list-number`
                                        }
                                        text={`Nº ····${rowData.accountNumber?.slice(-4)}`}
                                    />
                                </GridTable.Data>
                            </GridTable.Container>
                        </GridTable>
                    </GridTable.Data>
                    <GridTable.Data
                        key={4}
                        columnStart={isDesktop ? 2 : 1}
                        rowStart={isDesktop ? 1 : 2}
                        alignX="flex-start"
                        alignY="flex-start">
                        <CustomData
                            dataClass={
                                rowData.blocked === "S"
                                    ? `accounts-account-list-data ${
                                          rowData.totalBalance < 0 ? "account-list-data-negative" : ""
                                      } blocked`
                                    : `accounts-account-list-data ${
                                          rowData.totalBalance < 0 ? "account-list-data-negative" : ""
                                      }`
                            }
                            titleText="accounts.currentBalance"
                            titleTextType="I18N"
                            valueText={rowData.totalBalance ? rowData.totalBalance : "0"}
                            valueTextType={rowData.currency}
                        />
                    </GridTable.Data>
                    <GridTable.Data
                        key={5}
                        columnStart={isDesktop ? 3 : 2}
                        rowStart={isDesktop ? 1 : 2}
                        alignX="flex-start"
                        alignY="flex-start">
                        <CustomData
                            dataClass={
                                rowData.blocked === "S"
                                    ? `accounts-account-list-data ${
                                          rowData.proyectedOverdraftBalance < 0 ? "account-list-data-negative" : ""
                                      } blocked`
                                    : `accounts-account-list-data ${
                                          rowData.proyectedOverdraftBalance < 0 ? "account-list-data-negative" : ""
                                      }`
                            }
                            titleText="accounts.overdraftAgreement"
                            titleTextType="I18N"
                            valueText={rowData.proyectedOverdraftBalance ? rowData.proyectedOverdraftBalance : "0"}
                            valueTextType={rowData.currency}
                        />
                    </GridTable.Data>
                    <GridTable.Data
                        key={5}
                        columnStart={isDesktop ? 4 : 1}
                        rowStart={isDesktop ? 1 : 3}
                        alignX="flex-start"
                        alignY="flex-start">
                        <CustomData
                            dataClass={
                                rowData.blocked === "S"
                                    ? `accounts-account-list-data ${
                                          rowData.availableBalance < 0 ? "account-list-data-negative" : ""
                                      } blocked`
                                    : `accounts-account-list-data ${
                                          rowData.availableBalance < 0 ? "account-list-data-negative" : ""
                                      }`
                            }
                            titleText="accounts.availableAccountBalance"
                            titleTextType="I18N"
                            valueText={rowData.availableBalance ? rowData.availableBalance : "0"}
                            valueTextType={rowData.currency}
                        />
                    </GridTable.Data>
                    <GridTable.Data
                        key={6}
                        columnStart={isDesktop ? 5 : 2}
                        rowStart={1}
                        alignX={isDesktop ? "flex-start" : "flex-end"}
                        alignY="flex-start">
                        <CustomButton
                            pullRight
                            {...{
                                icon: "images/figma/icon/menu-mobile.svg",
                                options: [
                                    {
                                        text:
                                            "administration.permissions.advanced.section.transfers_transfer-thirdParties.title",
                                        textType: "I18N",
                                        func: () => handleOtherTransfer(rowData.productId, rowData.currency),
                                    },
                                    {
                                        text: "echecks.new",
                                        textType: "I18N",
                                        func: () => handleEmitEcheq(rowData.productId),
                                    },
                                ],
                            }}
                        />
                    </GridTable.Data>
                </GridTable.Container>
            ))}
            {hasMoreData && (
                <Button
                    bsStyle="link"
                    onClick={displayNextBatch}
                    image="images/figma/icon/arrow.svg"
                    label="global.showMore"
                    className="view-more"
                />
            )}
        </GridTable>
    );
};

AccountListFC.propTypes = {
    dataToList: arrayOf(
        shape({
            idProduct: string.isRequired,
            number: string,
            countableBalance: string,
            consolidatedAmount: string,
            balance: string.isRequired,
        }),
    ).isRequired,
    isDesktop: bool.isRequired,
    dispatch: func.isRequired,
    displayNextBatch: func.isRequired,
    hasMoreData: bool.isRequired,
};

export default connect()(AccountListFC);
